const quotes = [
    'It is not events that disturb people, it is their judgments concerning them. \n- Epictetus',
    'The happiness of your life depends upon the quality of your thoughts. \n- Marcus Aurelius',
    'No man is free who is not master of himself. \n- Epictetus',
    'We suffer more often in imagination than in reality. \n- Seneca',
    "Circumstances don't make the man, they only reveal him to himself. \n- Epictetus",
    "It's not what happens to you, but how you react to it that matters. \n- Epictetus",
    'The only way to do harm is to do nothing at all. \n- Marcus Aurelius',
    'He who fears death will never do anything worth of a man who is alive. \n- Seneca',
    'Difficulties strengthen the mind, as labor does the body. \n- Seneca',
    'How long are you going to wait before you demand the best for yourself? \n- Epictetus',
    'The universe is change; our life is what our thoughts make it. \n- Marcus Aurelius',
];

export function getRandomQuote(): string {
    const randomIndex = Math.floor(Math.random() * quotes.length);
    return quotes[randomIndex];
}
